import { useEffect, useState } from 'react';
import s from './MarketingModalTwoMini.module.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { clearHTML } from 'utils/clearHTML';
const API_URL = process.env.REACT_APP_API_ADDRESS

export const MarketingModalTwoMini = ({modal}: any) => {

  // ### State
  const [show, setShow] = useState(false)
  const {i18n} = useTranslation()
  const navigate = useNavigate()
  
  const image = `${modal?.image_mini?.[i18n.language] || modal?.image_mini?.[modal?.image_mini?.default_image]}`

  // ### Effects
    useEffect(()=>{
        if(modal){
            setInterval(() => {
                handleCheckModal(modal.interval, modal.active)
            }, 3000)
        }
    },[modal]);

    // ### Functions
    function handleCheckModal(interval: any, active: any){
        if(!active) return
        const storageModal = localStorage.getItem(`modal${modal.id}`)
        if(!storageModal){
            const newDate = new Date()
            newDate.setHours(newDate.getHours() + Number(interval))
            localStorage.setItem(`modal${modal.id}`, newDate.toISOString())
            setShow(true)
        }else{
            const now = new Date()
            const modalDate = new Date(storageModal)
            if(now > modalDate){
                setShow(true)
                now.setHours(now.getHours() + Number(interval))
                localStorage.setItem(`modal${modal.id}`, now.toISOString())
            }
        }
    }

  // ### Views

  return(
      <div className={s.modal}>
        <img className={s.background} src={image} alt="background" />
        <div className={s.content}>
          <p className={s.title}>{clearHTML(modal.title[i18n.language])}</p>
          <p className={s.description} dangerouslySetInnerHTML={{__html: modal.description?.[i18n.language]}}></p>
          {
            modal?.is_button ? 
            <div className={s.button}>
                <span className={s.button_title}>{clearHTML(modal?.button_text[i18n.language])}</span>
            </div> : null
          }
        </div>
      </div>
  )
}